import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAuthStorage } from '../../utils/storageUtils';

const PermissionDenied = () => {
    const navigate = useNavigate()
    const handleRefresh = () => {
        window.location.reload();
    };

    // const handleLogin = () => {
    //     // You can replace this with your login route or function
    //     navigate('/login')
    // };


      const handleLogin = () => {
        // Clear token and other auth data before navigating to login
        clearAuthStorage();
        // Navigate to login
        navigate('/login')
    };

    return (
        <div className="bg-gray-100 min-h-screen flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4 text-center">
                {/* Image placeholder */}
                <div className="mb-6">
                    <div className="w-32 h-32 mx-auto bg-red-100 rounded-full flex items-center justify-center">
                        {/* You can replace this SVG with your own image */}
                        <svg
                            className="w-16 h-16 text-red-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728"
                            />
                        </svg>
                    </div>
                </div>

                {/* Error message */}
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Access Denied</h1>
                <p className="text-gray-600 mb-8">You are not allowed to access this application</p>

                {/* Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={handleRefresh}
                        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-lg transition duration-200 ease-in-out transform hover:scale-105"
                    >
                        Refresh
                    </button>
                    <button
                        onClick={handleLogin}
                        className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-lg transition duration-200 ease-in-out transform hover:scale-105"

                    >
                        Login
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PermissionDenied;